export default __webpack_public_path__ + "static/2-external-api-3351dc811dcce52d182015b2d76b0661.jpg";